/**
 * htmldiff-js splits "words" with /[\w#@]+/, which only matches ASCII letters.
 * Danish æ/ø/å break tokens mid-word (e.g. "Ophævet" → "Oph", "æ", "vet") and
 * produce broken highlights. Encode to ASCII placeholders before diffing, then
 * restore afterward.
 */
const DANISH_TO_PLACEHOLDER: ReadonlyArray<[string, string]> = [
  ["æ", "ZZae1"],
  ["ø", "ZZoe1"],
  ["å", "ZZaa1"],
  ["Æ", "ZZAE1"],
  ["Ø", "ZZOE1"],
  ["Å", "ZZAA1"],
];

const PLACEHOLDER_TO_DANISH = new Map(
  DANISH_TO_PLACEHOLDER.map(([danish, placeholder]) => [placeholder, danish])
);

export const encodeDanishCharsForHtmlDiff = (html: string): string => {
  let encoded = html;
  for (const [danish, placeholder] of DANISH_TO_PLACEHOLDER) {
    encoded = encoded.split(danish).join(placeholder);
  }
  return encoded;
};

export const decodeDanishCharsFromHtmlDiff = (html: string): string => {
  let decoded = html;
  for (const [placeholder, danish] of PLACEHOLDER_TO_DANISH) {
    decoded = decoded.split(placeholder).join(danish);
  }
  return decoded;
};
